// src/features/prescriptions/prescriptionSelectors.js
import { createSelector } from 'reselect';

const selectPrescriptionsState = (state) => state.prescriptions;

export const selectUploadStatus = createSelector(
  [selectPrescriptionsState],
  (prescriptionsState) => ({
    uploadComplete: prescriptionsState.uploadComplete,
    loading: prescriptionsState.loading,
    error: prescriptionsState.error,
  })
);
